
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcAudioRecordingItem as ObcAudioRecordingItemElement} from '@oicl/openbridge-webcomponents/dist/components/audio-recording-item/audio-recording-item.js';
 
 
 

 
 export const ObcAudioRecordingItem = createComponent({
   react: React,
   tagName: 'obc-audio-recording-item',
   elementClass: ObcAudioRecordingItemElement,
   events: {
     
     onStatusToggle: 'status-toggle' as EventName<CustomEvent<{isPlaying: boolean}>>,
   }
  });
 
 